import {priority} from '@priority-software/priority-proto-api/lib';
import {languageTabs} from '../../../components/RuleDialog/parts/AutomationActionToolbar/constants';
import {AlertGWTType, GWTMetaData} from '../api/types';

type coverLetterXmlType = {
    hebrewCoverLetter: priority.netitems.form.IAlertMessage | null;
    englishCoverLetter: priority.netitems.form.IAlertMessage | null;
};
type BpmAlert = {
    AlertValues: AlertGWTType;
} & GWTMetaData;

const englishLanguage = languageTabs[0];
const hebrewLanguage = languageTabs[1];

export const coverLetterToXmlData = (rule: priority.netitems.form.IAlert): coverLetterXmlType => {
    let hebrewCoverLetter = null,
        englishCoverLetter = null;
    rule.CoverLetters?.forEach((coverLetter, index) => {
        if (coverLetter.Language === parseInt(hebrewLanguage.id)) {
            hebrewCoverLetter = coverLetter;
        } else {
            englishCoverLetter = coverLetter;
        }
    });
    return {
        hebrewCoverLetter,
        englishCoverLetter
    };
};

const setCoverLetter = (language: number, coverLetter: string, subject: string) => {
    return {
        Language: language,
        Message: coverLetter,
        Subject: subject
    };
};

export const bpmAlertToCoverLetter = (
    data: BpmAlert
): priority.netitems.form.IAlertMessage[] | null => {
    const alertData = data?.AlertValues?.[0];
    if (!alertData) return null;
    const coverLetters: priority.netitems.form.IAlertMessage[] = [];
    coverLetters[englishLanguage.id] = setCoverLetter(
        Number(englishLanguage.id),
        alertData?.engmessage || alertData?.CoverLetters?.[0]?.coverletter2,
        alertData?.engsubject
    );
    coverLetters[hebrewLanguage.id] = setCoverLetter(
        Number(hebrewLanguage.id),
        alertData?.message || alertData?.CoverLetters?.[0]?.coverletter,
        alertData?.subject
    );

    if (coverLetters[englishLanguage.id] || coverLetters[hebrewLanguage.id]) {
        return coverLetters;
    }
    return null;
};
